import axios from "axios";
import VueCookie from "vue-cookie";
import router from '../routes/router'
const qs = require("querystring");

let axiosInstance = axios.create({
  //  baseURL: getBaseUrl(),
  timeout: 120000
});

axiosInstance.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // Do something with response error
    if (error.response.status === 401) {
      router.push('/login')
    }
    return Promise.reject(error);
  }
);

class HttpRequest {
  constructor() {
    axios.defaults.baseURL = this.getBaseUrl();
    this.axios = axios;
  }

  getBaseUrl() {
    return process.env.VUE_APP_API_BASE_URL;
  }

  getApiUrl() {
    return process.env.VUE_APP_API_BASE_URL + "/api/";
  }

  setHeader(header) {
    axiosInstance.defaults.headers.common["Authorization"] = VueCookie.get(
      "token"
    );
    axiosInstance.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded";
  }

  get(methodName, data) {
    return axiosInstance.get(this.getApiUrl() + methodName, {
      params: data,
      headers: { Authorization: "Bearer " + VueCookie.get("token") }
    });
  }

  get_blob(methodName, data) {
    return axiosInstance.get(this.getApiUrl() + methodName, {
      params: data,
      responseType: 'blob',
      headers: { Authorization: "Bearer " + VueCookie.get("token") }
    });
  }

  get_array_buffer(methodName, data) {
    return axiosInstance.get(this.getApiUrl() + methodName, {
      params: data,
      responseType: 'arraybuffer',
      headers: { Authorization: "Bearer " + VueCookie.get("token") }
    });
  }

  get_guest(methodName, data) {
    return axiosInstance.get(this.getBaseUrl() + methodName, {
      params: data,
    });
  }

  put(methodName, data) {
    return axiosInstance.put(this.getApiUrl() + methodName, qs.stringify(data),
    {
      headers: { Authorization: "Bearer " + VueCookie.get("token") }
    });
  }

  // PUT with a JSON body — mirrors postJson. Needed for endpoints that bind a
  // struct holding an array (e.g. BillingList), which qs.stringify + Echo's
  // form binder cannot round-trip.
  putJson(methodName, data) {
    return axiosInstance.put(
      this.getApiUrl() + methodName,
      data,
      {
        headers: {
          Authorization: "Bearer " + VueCookie.get("token"),
          'Content-Type': "application/json"
        }
      }
    );
  }

  putFormData(methodName, data) {
    return axiosInstance.put(
      this.getBaseUrl() + "/api/" + methodName,
      data,
      {
        headers: { 
          Authorization: "Bearer " + VueCookie.get("token") ,
          'Content-Type': "multipart/form-data"
        }
      }
    );
  }

  // delete(methodName, id) {
  //   return axiosInstance.delete(this.getApiUrl() + methodName, { params: { id: id },headers: { Authorization: "Bearer " + VueCookie.get("token") } });
  // }

  delete(methodName, data) {
    return axiosInstance.delete(this.getApiUrl() + methodName,
    {
      headers: { Authorization: "Bearer " + VueCookie.get("token") }
    });
  }

  post(methodName, data) {
    return axiosInstance.post(
      this.getBaseUrl() + "/api/" + methodName,
      qs.stringify(data),
      {
        headers: { Authorization: "Bearer " + VueCookie.get("token") }
      }
    );
  }

  postJson(methodName, data) {
    return axiosInstance.post(
      this.getBaseUrl() + "/api/" + methodName,
      data,
      {
        headers: { 
          Authorization: "Bearer " + VueCookie.get("token") ,
          'Content-Type': "application/json"
        }
      }
    );
  }

  postFormData(methodName, data) {
    return axiosInstance.post(
      this.getBaseUrl() + "/api/" + methodName,
      data,
      {
        headers: { 
          Authorization: "Bearer " + VueCookie.get("token") ,
          'Content-Type': "multipart/form-data"
        }
      }
    );
  }

  post_guest(methodName, data) {
    return axiosInstance.post(
      this.getBaseUrl() + methodName,
      qs.stringify(data)
    );
  }

  request(type, url, data) {
    let promise = null;
    switch (type) {
      case "GET":
        promise = axios.get(url, { params: data });
        break;
      case "POST":
        promise = axios.post(url, data);
        break;
      case "PUT":
        promise = axios.put(url, data);
        break;
      case "DELETE":
        promise = axios.delete(url, data);
        break;
      default:
        promise = axios.get(url, { params: data });
        break;
    }
    return promise;
  }
}

export default HttpRequest;
